module.exports = __webpack_public_path__ + "static/media/heart.d0e2f6c7.svg";